import { Capacitor } from '@capacitor/core';

/**
 * Check if running in Electron desktop app
 * Detects via CapacitorCustomPlatform exposed by the Electron preload script.
 * This is the authoritative check that confirms both Electron environment AND plugins are available.
 */
export function isElectron(): boolean {
    return (window as any).CapacitorCustomPlatform?.name === 'electron';
}

/**
 * Check if running on a native mobile platform (iOS/Android)
 * Excludes Electron desktop
 */
export function isNativeMobile(): boolean {
    return Capacitor.isNativePlatform() && !isElectron();
}

/**
 * Get the current platform name
 * Returns 'electron' for desktop, or Capacitor's platform for others
 */
export function getPlatform(): string {
    if (isElectron()) {
        return 'electron';
    }
    return Capacitor.getPlatform();
}

/**
 * Check if running on any native platform (mobile or desktop)
 */
export function isNativePlatform(): boolean {
    return Capacitor.isNativePlatform() || isElectron();
}

/**
 * Check if running in Electron on macOS
 */
export function isMacOS(): boolean {
    const isMac = (): boolean => {
        return navigator.platform.toLowerCase().includes('mac') ||
           navigator.userAgent.toLowerCase().includes('mac');
    }

    return isElectron() && isMac();
}
